import { Injectable } from '@angular/core';

import { RestService } from './rest.service';

import { environment } from '../../../environments/environment';

@Injectable()
export class InvoiceService {
  constructor(private readonly rest: RestService) {}

  getInvoices(): Promise<any> {
    return this.rest.get(`${environment.apiUrl}/api/core/invoice`);
  }

  getInvoiceById(id: number): Promise<any> {
    return this.rest.get(`${environment.apiUrl}/api/core/invoice/${id}`);
  }
}
